import { navigate } from 'gatsby'
import React, { FC, useRef } from 'react'
import { ComponentProductDownload } from '../../../models/components/productDownload'
import { ProductDownloadContent } from './subcomponents/ProductDownloadContent'

type Props = {
  data: ComponentProductDownload
}

const ProductDownload: FC<Props> = ({ data }) => {
  const downloadRef = useRef<HTMLAnchorElement>(null)
  let progressPageSlug = ''

  const productDownloadData = {
    finePrint: data.finePrint || '',
    eyebrow: data.tileEyebrow || '',
    logosIntro: data.logosIntro || '',
    logosOutro: data.logosOutro || '',
    ctaText: data.ctaText || '',
    progressPage: data.progressPage || {},
    products: data.products || [],
    logos: data.logos || [],
    externalDownload: data.externalDownload || null,
    file: data.fileDownload || null,
  }

  if ('slug' in productDownloadData.progressPage) {
    const slug: any = productDownloadData.progressPage.slug || ''

    if (slug.charAt(0) === '/') {
      progressPageSlug = slug
    } else {
      progressPageSlug = `/${slug}`
    }
  }

  const handleButtonClick = (event: any) => {
    event?.preventDefault()
    if (downloadRef && downloadRef.current) {
      downloadRef.current.click()
      if (progressPageSlug) {
        navigate(progressPageSlug)
      }
    }
  }

  return (
    <ProductDownloadContent
      productDownloadData={productDownloadData}
      handleButtonClick={handleButtonClick}
      downloadRef={downloadRef}
    />
  )
}

export default ProductDownload
